export default {
  copyright: null,
  dissertation: null,
};



// WEBPACK FOOTER //
// ./src/file-upload/fileHandles.js